import React, {useState, useEffect} from 'react';
import {FaBars} from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import { MobileIcon, Nav, NavbarContainer, NavItem, NavLinks, NavLogo, NavMenu } from './NavbarElements';



const Navbar = ({toggle}) => {

    const [scrollNav, setScrollNav] = useState(false)
        const changeNav = () => {
            if(window.scrollY >=80){
                setScrollNav(true)
            }else{
                setScrollNav(false)
            }
        }

    useEffect(() => {
        window.addEventListener('scroll', changeNav)
    },[])

    const toogleHome = ()=>{
        scroll.scrollToTop()
    }

    return (
        <>
        <IconContext.Provider value={{ color: '#fff'}}>
            <Nav scrollNav={scrollNav}>
                <NavbarContainer>
                    <NavLogo to='/' onClick={toogleHome}>
                        FENIX
                    </NavLogo>
                        <MobileIcon onClick={toggle}>
                            <FaBars>
                            </FaBars>
                        </MobileIcon>
                    <NavMenu>
                        <NavItem>
                            <NavLinks to="about" smooth={true} duration={500} spy={true} exact='true' offset={-80}  >About Us</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="discover"  smooth={true} duration={500} spy={true} exact='true' offset={-80} >Discover</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="services"  smooth={true} duration={500} spy={true} exact='true' offset={-80} >Services</NavLinks>
                        </NavItem>
                        
                        <NavItem>
                            <NavLinks to="experiences"  smooth={true} duration={500} spy={true} exact='true' offset={-80} >Experience</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="contact"  smooth={true} duration={500} spy={true} exact='true' offset={-80} >Contact</NavLinks>
                        </NavItem>

                    </NavMenu>
                   {/*  <NavBtn>
                        <NavBtnLink>
                            Sign Up
                        </NavBtnLink>
                    </NavBtn> */}
                </NavbarContainer>
            </Nav>
            </IconContext.Provider>
        </>
    )
};

export default Navbar;
